module.exports = __webpack_public_path__ + "img/hsbc.1c8d12c2.svg";